// extracted by mini-css-extract-plugin
export var header = "_x5-1";
export var maskBottom = "_x5-6";
export var maskMiddle = "_x5-7";
export var maskTop = "_x5-5";
export var root = "_x5-0";
export var scrollDownButton = "_x5-3";
export var scrollDownButtonHidden = "_x5-4";
export var viewport = "_x5-2";